import { get, Response } from '@/api'
import { PromotionalProduct } from '@/generatedTypes'

export default {
  getPromotionalProducts: (): Promise<Response<PromotionalProduct[]>> => {
    return get<PromotionalProduct[]>('/products/promoted')
  }
}
